import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const stats = [{
  value: 2400,
  suffix: '+',
  label: 'Attendees activated',
  color: 'text-brand-navy'
}, {
  value: 94,
  suffix: '%',
  label: 'Satisfaction score',
  color: 'text-brand-teal'
}, {
  value: 12,
  suffix: ' hrs',
  label: 'Saved per event',
  color: 'text-brand-coral'
}, {
  value: 40,
  suffix: '+',
  label: 'Events delivered',
  color: 'text-brand-navy'
}];
function Counter({
  from,
  to,
  duration = 2,
  suffix = ''
}: {
  from: number;
  to: number;
  duration?: number;
  suffix?: string;
}) {
  const [count, setCount] = useState(from);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: 0.5
  });
  useEffect(() => {
    if (isInView) {
      let startTime: number;
      let animationFrame: number;
      const step = (timestamp: number) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / (duration * 1000), 1);
        // Ease out expo
        const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
        setCount(Math.floor(easeProgress * (to - from) + from));
        if (progress < 1) {
          animationFrame = requestAnimationFrame(step);
        }
      };
      animationFrame = requestAnimationFrame(step);
      return () => cancelAnimationFrame(animationFrame);
    }
  }, [isInView, from, to, duration]);
  return <span ref={ref} data-id="element-7396">
      {count.toLocaleString()}
      {suffix}
    </span>;
}
export function StatsBand() {
  return <section className="bg-slate-50 py-16 border-y border-slate-100 relative overflow-hidden" data-id="element-7397">
      <div className="absolute inset-0 pointer-events-none" data-id="element-7398">
        <div className="absolute top-1/2 left-1/4 w-64 h-64 bg-brand-teal/[0.03] rounded-full blur-3xl -translate-y-1/2" data-id="element-7399" />
        <div className="absolute top-1/2 right-1/4 w-64 h-64 bg-brand-coral/[0.03] rounded-full blur-3xl -translate-y-1/2" data-id="element-7400" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10" data-id="element-7401">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 divide-x divide-slate-200/50" data-id="element-7402">
          {stats.map((stat, i) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`text-center ${i % 2 !== 0 ? 'pl-8 md:pl-12' : i !== 0 ? 'pl-8 md:pl-12 md:border-l md:border-slate-200/50' : ''} ${i === 2 ? 'border-l-0 md:border-l' : ''}`} data-id="element-7403">
              <div className={`text-4xl md:text-5xl font-bold tracking-tight mb-2 ${stat.color}`} data-id="element-7404">
                <Counter from={0} to={stat.value} suffix={stat.suffix} data-id="element-7405" />
              </div>
              <div className="text-sm md:text-base font-medium text-slate-500" data-id="element-7406">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}